import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Modal } from "@/pages/Notizie";
import { Share2 } from "lucide-react";
import { PersonaSearch } from "@/components/PersonaSearch";

const inp = "w-full px-3 py-2.5 rounded-lg bg-white border border-[var(--border)] outline-none text-sm focus:border-[#FC82ED]";
const quando = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Rome" }) : "");

export function GiraAField({ value, onChange, note, onNote, testid = "f-gira" }) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/notizie-girabili").then((r) => setList(r.data)).catch(() => {}); }, []);
  if (!list.length) return null;
  return (
    <div className="rounded-xl border border-[var(--border)] bg-[#F7F7F8] p-3 space-y-2" data-testid={testid}>
      <div className="text-[11px] font-bold uppercase tracking-wide text-[var(--muted)] flex items-center gap-1"><Share2 size={12} /> Gira a (facoltativo)</div>
      <PersonaSearch testid={`${testid}-a`} single people={list} sel={value ? [value] : []} onChange={(v) => onChange(v[0] || "")} placeholder="Cerca persona… (vuoto = la gestisco io)" />
      {value && <textarea data-testid={`${testid}-note`} rows={2} value={note || ""} onChange={(e) => onNote(e.target.value)} placeholder="Note per chi la riceve (es. «È la vicina di mia madre, chiamala tu, sa che la cerchi»)" className={inp} />}
    </div>
  );
}

export function GiraModal({ id, onClose, onDone }) {
  const [a, setA] = useState("");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const save = async () => {
    if (!a) return toast.error("Scegli a chi girarla");
    setSaving(true);
    try { await api.post(`/notizie/${id}/gira`, { gira_a: a, note }); window.dispatchEvent(new Event("notizia-girata")); toast.success("Notizia girata"); onDone(); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <Modal title="Gira la notizia" onClose={onClose} onSave={save} saving={saving || !a} saveLabel="Gira" testid="gira-modal">
      <GiraAField value={a} onChange={setA} note={note} onNote={setNote} testid="gira" />
    </Modal>
  );
}

export function SegnalataDa({ n, testid }) {
  if (!n?.segnalata_da_nome || n.segnalata_da_id === n.owner_agent_id) return null;
  return <span data-testid={testid} className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-0.5 rounded-full bg-[#FC82ED]/15 text-[#9B1C85]"><Share2 size={11} /> Segnalata da {n.segnalata_da_nome}</span>;
}

const COL = { "Da contattare": "bg-slate-100 text-slate-700", Contattata: "bg-sky-100 text-sky-800", "Valutazione fissata": "bg-amber-100 text-amber-800", "Incarico preso": "bg-emerald-100 text-emerald-700", Persa: "bg-red-100 text-red-700" };

export function SegnalateDaMe() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => {
    const load = () => api.get("/notizie-segnalate").then((r) => setItems(r.data)).catch(() => setItems([]));
    load();
    window.addEventListener("notizia-girata", load);
    return () => window.removeEventListener("notizia-girata", load);
  }, []);
  if (!items) return <div className="skeleton h-32 rounded-2xl" />;
  if (!items.length) return <p className="text-sm text-[var(--muted)]" data-testid="segnalate-vuoto">Non hai ancora girato notizie ad altri.</p>;
  return (
    <div className="space-y-2" data-testid="segnalate-lista">
      <p className="text-xs text-[var(--muted)]">Notizie che hai girato ad altri: puoi aggiungere informazioni, la gestione resta a chi le ha ricevute.</p>
      {items.map((x) => (
        <div key={x.id} data-testid={`segnalata-${x.id}`} onClick={() => nav(`/notizie/${x.id}`)} className="card-immo p-4 flex items-center gap-3 flex-wrap cursor-pointer hover:shadow-md transition-shadow">
          <div className="flex-1 min-w-[200px]">
            <div className="font-semibold text-sm">{x.indirizzo || "Notizia"}{x.comune ? `, ${x.comune}` : ""}</div>
            <div className="text-xs text-[var(--muted)]">{x.nome ? `${x.nome} · ` : ""}Girata a <b className="text-[#111111]">{x.girata_a}</b> · aggiornata {quando(x.updated_at)}</div>
          </div>
          <span data-testid={`segnalata-stato-${x.id}`} className={`px-2.5 py-1 rounded-full text-[11px] font-bold ${COL[x.stato] || COL["Da contattare"]}`}>{x.stato}</span>
        </div>
      ))}
    </div>
  );
}

export function useSchedaSegnalate(setView) {
  const nav = useNavigate();
  useEffect(() => {
    if (new URLSearchParams(window.location.search).get("scheda") === "segnalate") { setView("segnalate"); nav("/notizie", { replace: true }); }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
